const user = {
  state: {
    user: '',
    userInfo:{}, //用户信息
    status: '',
    code: '',
    token: '',  //token
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_TOKEN: (state, token) =>{  //赋值token
      state.token = token
    },
    SET_USERINFO: (state, code) => {  //赋值用户信息
      state.userInfo = code
    },
    
  },

  actions: {
    // 获取token
    getToken({commit}, token) {
      commit('SET_TOKEN',token)
    },
     // 获取用户信息
     getUserInfo({ commit}, state) {
      commit('SET_USERINFO', state)
    },
    
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js